module.exports = __webpack_public_path__ + "static/fonts/realiance-icons.106f199d.woff";